import React, { Component } from "react";

import { updatePassword, keepAccessTokenUpdated } from "../utilities/extraAPIs";
import { InputLabel, Input, Button, Table, TableBody, TableRow, TableCell, Card } from "@material-ui/core";

const styles = {
  margin: 20,
  width: 500,
  height: "100%",
  textAlign: "left"
};

class ChangePasswordView extends Component {
  state = {
    oldPassword: "",
    newPassword: "",
    confirmedPassword: "",
    result: ""
  };

  storeInputValueToState = event => {
    const { id, value } = event.target;
    this.setState({ [id]: value });
  };

  async changePassword() {
    let result = "";
    this.setState({ result });
    const { oldPassword, newPassword, confirmedPassword } = this.state;

    if (newPassword != confirmedPassword)
      result = "Those NEW passwords didn't match. Try again.";
    else {
      await keepAccessTokenUpdated();
      const userID = localStorage.getItem("userId");
      result = await updatePassword(userID, oldPassword, newPassword);
    }

    this.setState({ result });
  }

  render() {
    const { oldPassword, newPassword, confirmedPassword, result } = this.state
    return (
      <Card>
        <form onSubmit={ e => { this.changePassword(); e.preventDefault(); } } method="post" style={ styles }>

          <Table style={ { width: "100%" } }>
            <TableBody>
              <TableRow>
                <TableCell><InputLabel>Old Password: </InputLabel></TableCell>
                <TableCell><Input type="password" id="oldPassword" onChange={ this.storeInputValueToState } required /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell><InputLabel>New Password: </InputLabel></TableCell>
                <TableCell><Input type="password" id="newPassword" onChange={ this.storeInputValueToState } required /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell><InputLabel>Confirm New Password: </InputLabel></TableCell>
                <TableCell><Input type="password" id="confirmedPassword" onChange={ this.storeInputValueToState } /></TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <br />
          <div>
            <span style={ { color: "red" } }>{ this.state.result }</span>
          </div>

          <Button variant="contained" color="primary" type="submit"
            disabled={ !oldPassword || !newPassword || !confirmedPassword || result.includes('Password has been changed') }
          >Change</Button>
        </form>
      </Card>
    );
  }
}

export default ChangePasswordView;
